/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React from 'react';
import EditIcon from '@mui/icons-material/Edit';

import styles from './EditBadge.module.scss';

export function EditBadge({ onClick }: { onClick: () => void }) {
  return (
    <div className={`${styles.editBadge} editBadge`} onClick={onClick}>
      <EditIcon fontSize="small" />
    </div>
  );
}
